import { AppBar, DialogContent, IconButton, Toolbar, Typography } from '@material-ui/core';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import { MdClose } from 'react-icons/md';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/TarefaApontamentoActions';

class TarefaApontamentoDialog extends XAPPComponent {

    getLabel = () => {
        const { apontamento } = this.props;
        switch (apontamento) {
            case "7": return "Orçamento";
            case "0": return "Pedido";
            case "1": return "Caixa";
            case "3": return "Estoque";
            case "18": return "Orçamento";
            case "4": return "Produtos e serviços";
            case "5": return "Caixa";
            default: return "Apontamentos";
        }
    }

    render() {
        const { children, openDialog, id, dialog } = this.props;
        return (
            <XAPPDialog
                id="TarefaApontamento"
                open={dialog === id}
                onClose={() => openDialog(null)}
                fullWidth
                fullScreen
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {this.getLabel()}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent classes={{ root: "px-24" }}>
                    {children}
                </DialogContent>
            </XAPPDialog>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog: Actions.openDialog,
    }, dispatch);
}

function mapStateToProps({ TarefaApontamento }) {
    return {
        dialog: TarefaApontamento.dialog,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TarefaApontamentoDialog);
